import React, { useState, useEffect } from "react";

import {
  Accordion,
  AccordionItem,
  Chip,
  Icon,
  Tab,
  TabItem,
  Typography,
} from "@plum-xoxo/admin-dsm";
import { StyledIcon } from "../../modules/Accounts/PlatformPreferences/Component/styled";
import styled from "styled-components";
import moment from "moment";
import { DATE_FORMAT } from "../../constants/AppConstant";
import SmsPreviewCommon from "./SmsPreviewCommon";
import NewEmailPreview from "../NewEmailPreviewTemplate";
import WhatsApp from "../WhatsappTemplate";

const StyledDiv = styled.div`
  gap: 20px;
`;
const Styled8pxDiv = styled.div`
  gap: 8px;
`;

const StyledTab = styled(Tab).attrs()`
  & > .eui-tab-nav {
    display: none;
  }
`;

const REWARD_TYPE = {
  1: "points-distribution",
  2: "code-distribution",
  3: "link-distribution",
  4: "plum-pro-distribution",
};
const sessionStorageType = {
  1: "xoxoPointState",
  2: "xoxoCodeState",
  3: "xoxoLinkState",
  4: "plumProState",
};
const AccordionTitle = ({ firstRewardSent }) => {
  return (
    <>
      <StyledDiv className="d-flex align-items-center w-100">
        <StyledIcon iconName="PlumMessage" color="primary" shade="c02" />
        <div className="d-flex align-items-center">
          <Typography.ButtonText>
            Personalise Communications
          </Typography.ButtonText>
          {firstRewardSent && (
            <Typography.ButtonText color="dark" shade="c100" className="ml-2">
              {" ("}optional{")"}
            </Typography.ButtonText>
          )}
        </div>
      </StyledDiv>
    </>
  );
};

const StyledAccordion = styled(Accordion).attrs()`
  .eui-accordion-title {
    width: 100%;
  }
  .eui-accordion-content {
    padding: 0;
  }

  .eui-accordion-icon {
    padding: 0px 12px;
  }
`;

const GreyBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.light.c100};
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  border-radius: 8px;
  margin: 24px;
  padding: 24px;
  .img-box {
    width: 80%;
  }
`;
const EmailSmsAccordion = (props) => {
  const {
    smsText,
    setSmsText,
    selectedSite,
    selectedTemplate,
    setSelectedTemplate,
    emailSubject,
    emailHeading,
    emailTitle,
    setEmailTitle,
    emailLogo,
    setEmailSubject,
    setEmailHeading,
    setEmailLogo,
    currencyCode,
    expiryMonth,
    buttonText,
    setButtonText,
    setShowEditMessage,
    setShowEgiftText,
    setEditColCampaign,
    setLoader,
    setIsLoading = () => {},
    rewardType,
    activeSetting,
    sendMode,
    accountReducer,
    recipientData,
    firstRewardSent,
    whatsappImage,
    setWhatsappImage,
    whatsappText,
    setWhatsappText = () => {},
    whatsappAlbumImageId,
    setWhatsappAlbumImageId = () => {},
  } = props;
  const [tabInView, setTabInView] = useState(0);
  const [emailCount, setEmailCount] = useState(0);
  const [phoneCount, setPhoneCount] = useState(0);

  const checkModeCount = () => {
    let phone = 0,
      email = 0;
    for (let element of recipientData) {
      if (element.to_phone_number !== "") {
        phone = phone + 1;
      }
      if (element.email !== "") {
        email = email + 1;
      }
    }
    if (recipientData.length === 0) {
      phone += 1;
      email += 1;
    }
    setPhoneCount(phone);
    setEmailCount(email);
  };

  let validTill = moment(new Date())
    .add(props.expiryMonth?.value, "days")
    .format(DATE_FORMAT);

  useEffect(() => {
    if (sendMode?.includes("email")) setTabInView(0);
    else if (sendMode?.includes("sms")) setTabInView(1);
    else if (sendMode?.includes("whatsapp")) setTabInView(2);
    else setTabInView(0);
  }, [sendMode]);

  useEffect(() => {
    checkModeCount();
  }, [recipientData]);

  // useEffect(() => {
  //   let sessionData = {};
  //   sessionData = sessionStorage.getItem(sessionStorageType[rewardType]);
  //   setButtonText(sessionData?.buttonText || buttonText);
  //   setEmailLogo(sessionData?.emailLogo || emailLogo);
  //   setEmailSubject(sessionData?.emailSubject || emailSubject);
  //   setEmailHeading(sessionData?.emailHeading || emailHeading);
  //   setSmsText(sessionData?.smsText || smsText);
  //   setSelectedTemplate(sessionData?.selectedTemplate || selectedTemplate);
  // }, []);
  const updateState = (data) => {
    const keyArray = Object.keys(data);
    for (let i = 0; i < keyArray.length; i++) {
      const value = data[keyArray[i]];
      if (keyArray[i] === "emailSubject") setEmailSubject(value);
      else if (keyArray[i] === "selectedTemplate") setSelectedTemplate(value);
      else if (keyArray[i] === "emailHeading") setEmailHeading(value);
      else if (keyArray[i] === "emailTitle") setEmailTitle(value);
      else if (keyArray[i] === "emailLogo") setEmailLogo(value);
      else if (keyArray[i] === "buttonText") setButtonText(value);
      else if (keyArray[i] === "showEgiftText") setShowEgiftText(value);
      else if (keyArray[i] === "showEditMessage") setShowEditMessage(value);
      else if (keyArray[i] === "company_primary_logo") setEmailLogo(value);
      else if (keyArray[i] === "editColCampaign") setEditColCampaign(value);
      else if (keyArray[i] === "loader") setLoader(value);
      else if (keyArray[i] === "isLoading") setIsLoading(value);
      else if (keyArray[i] === "whatsappText") setWhatsappText(value);
      else if (keyArray[i] === "whatsappAlbumImageId")
        setWhatsappAlbumImageId(value);
      else if (keyArray[i] === "whatsappImage") setWhatsappImage(value);
    }
  };

  return (
    <StyledAccordion
      className="mt-16"
      activeItem={activeSetting === 1 ? 0 : -1}
    >
      <AccordionItem
        title={<AccordionTitle firstRewardSent={firstRewardSent} />}
      >
        <hr className="mt-24 mb-0" />
        <GreyBackgroundDiv>
          <Typography.BodySmall className="mb-0">
            This is a preview of how your recipients will receive their rewards
            via email and SMS. You can customise them to match your branding
            requirements.
          </Typography.BodySmall>
        </GreyBackgroundDiv>
        <Styled8pxDiv className="d-flex align-items-center mt-28 px-24">
          {sendMode?.includes("email") || rewardType === 4 ? (
            <Chip
              color="custom"
              backgroundColor={tabInView === 0 ? "primary" : "light"}
              backgroundShade={tabInView === 0 ? "c00" : "c200"}
              textColor={tabInView === 0 ? "primary" : "dark"}
              textShade={tabInView === 0 ? "c02" : "c200"}
              label={
                <>
                  <div className="d-flex align-items-center">
                    <Icon
                      iconName="PlumMessage"
                      color={tabInView === 0 ? "primary" : "dark"}
                      shade={tabInView === 0 ? "c02" : "c200"}
                    />
                    <Typography.LabelText className="ml-8">
                      Email
                    </Typography.LabelText>
                  </div>
                </>
              }
              size="medium"
              radius={20}
              onClick={() => {
                setTabInView(0);
              }}
            />
          ) : null}
          {sendMode?.includes("sms") || rewardType === 4 ? (
            <Chip
              color="custom"
              backgroundColor={tabInView === 1 ? "primary" : "light"}
              backgroundShade={tabInView === 1 ? "c00" : "c200"}
              textColor={tabInView === 1 ? "primary" : "dark"}
              textShade={tabInView === 1 ? "c02" : "c200"}
              label={
                <>
                  <div className="d-flex align-items-center">
                    <Icon
                      iconName="Chat"
                      color={tabInView === 1 ? "primary" : "dark"}
                      shade={tabInView === 1 ? "c02" : "c200"}
                    />
                    <Typography.LabelText className="ml-8">
                      SMS
                    </Typography.LabelText>
                  </div>
                </>
              }
              size="medium"
              radius={20}
              onClick={() => {
                setTabInView(1);
              }}
            />
          ) : null}
          {sendMode?.includes("whatsapp") ? (
            <Chip
              color="custom"
              backgroundColor={tabInView === 2 ? "primary" : "light"}
              backgroundShade={tabInView === 2 ? "c00" : "c200"}
              textColor={tabInView === 2 ? "primary" : "dark"}
              textShade={tabInView === 2 ? "c02" : "c200"}
              label={
                <>
                  <div className="d-flex align-items-center">
                    <Icon
                      iconName="PlumWhatsapp"
                      color={tabInView === 2 ? "primary" : "dark"}
                      shade={tabInView === 2 ? "c02" : "c200"}
                    />
                    <Typography.LabelText className="ml-8">
                      Whatsapp
                    </Typography.LabelText>
                  </div>
                </>
              }
              size="medium"
              radius={20}
              onClick={() => {
                setTabInView(2);
              }}
            />
          ) : null}
        </Styled8pxDiv>
        <StyledTab activeTab={tabInView} className="px-24">
          <TabItem>
            <NewEmailPreview
              useCase={REWARD_TYPE[rewardType]}
              validTill={validTill}
              selectedTemplate={selectedTemplate}
              updateState={updateState}
              site_id={selectedSite?.id ? selectedSite.id : 0}
              company_primary_logo={emailLogo}
              currencyCode={currencyCode}
              showEditMessage={true}
              emailSubject={emailSubject}
              emailHeading={emailHeading}
              emailTitle={emailTitle}
              showEgiftText={true}
              buttonText={buttonText || "Redeem Now"}
              selectedDate={moment(expiryMonth, "DD MM YYYY").format(
                DATE_FORMAT
              )}
              accountReducer={accountReducer}
            />
          </TabItem>
          <TabItem>
            <SmsPreviewCommon
              smsText={smsText}
              setSmsText={setSmsText}
              rewardType={rewardType}
            />
          </TabItem>
          <TabItem>
            <div className="mt-32">
              <WhatsApp
                whatsappText={whatsappText}
                whatsappAlbumImageId={whatsappAlbumImageId}
                whatsappImage={whatsappImage}
                updateState={updateState}
                rewardType={rewardType}
                site_id={selectedSite?.id ? selectedSite.id : 0}
              />
            </div>
          </TabItem>
        </StyledTab>
      </AccordionItem>
    </StyledAccordion>
  );
};

export default EmailSmsAccordion;
